import React, { useState } from "react";
import {
  showError,
  showSuccess,
} from "../../../../../../../../utils/showMessage.js";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Images from "../../../../../../../../utils/images.js";
import CrossButton from "../../../../../../../common/ButtonSpinner/CrossButton.js";
import GeneralButton from "../../../../../../../common/SaveButton/GeneralButton.js";
import CustomModal from "../../../../../../../common/CustomModal/CustomModal.js";
import "react-toastify/dist/ReactToastify.css";
import { FiPlusCircle, FiTrash2 } from "react-icons/fi";
import { Tooltip } from "@mui/material";
import { createTable } from "../../../../../../../../api/database_gui.js";

const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    paddingTop: "3px",
    paddingBottom: "3px",
    borderColor: "#ced4da",
    boxShadow: "none",
    fontFamily: '"Poppins"',
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
    color: "#717171",
    ":hover": {
      borderColor: "#ced4da",
    },
  }),
  option: (styles) => ({
    ...styles,
    fontFamily: '"Poppins"',
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
  }),
};

const DATATYPE_OPTIONS = {
  mysql: ["INT", "VARCHAR", "FLOAT", "BOOLEAN", "CHAR", "DECIMAL"],
  mssql: ["INT", "VARCHAR", "FLOAT", "BIT", "CHAR", "DECIMAL"],
  postgres: ["INT", "VARCHAR", "FLOAT", "BOOLEAN", "CHAR", "DECIMAL"],
};

// Remove the hardcoded database type
// const DEFAULT_DATABASE_TYPE = "postgres";
// const effectiveDbType = DEFAULT_DATABASE_TYPE;

const ColumnForm = ({
  column,
  index,
  handleColumnChange,
  handleCheckboxChange,
  removeColumn,
  pkSelected,
  canRemove,
  databaseInfo,
}) => {
  // Determine the effective database type
  const getEffectiveDbType = () => {
    if (databaseInfo === "MySQL") return "mysql";
    if (databaseInfo === "MSSQL") return "mssql";
    if (databaseInfo === "PostgreSQL") return "postgres";
    return "postgres"; // default fallback
  };

  const effectiveDbType = getEffectiveDbType();

  return (
    <div className="border rounded p-3 mb-3 bg-light position-relative">
      {canRemove && (
        <button
          type="button"
          className="text-muted position-absolute"
          style={{ top: "8px", right: "8px", fontSize: "18px", lineHeight: "1", background: "none", border: "none" }}
          onClick={() => removeColumn(index)}
          title="Remove column"
        >
          ×
        </button>
      )}
      <Row>
        <Col md={4}>
          <Form.Label className="input_label">
            Column Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            className="form_input_field"
            type="text"
            value={column.name}
            placeholder="Enter column name"
            onChange={(e) => handleColumnChange(index, "name", e.target.value)}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="input_label">
            Datatype{" "}
            <Tooltip
              title={`If select varchar or char datatype then you need to enter the length.`}
              placement="top-end"
            >
              <img
                src={Images.InfoIcon}
                alt="info"
                width="15"
                height="15"
                className="cursor_pointer"
              />
            </Tooltip>
          </Form.Label>
          <Form.Control
            as="select"
            className="form_input_field"
            value={column.type}
            style={{ selectStyles }}
            onChange={(e) => handleColumnChange(index, "type", e.target.value)}
          >
            <option value="">Select Datatype</option>
            {DATATYPE_OPTIONS[effectiveDbType]?.map((type, i) => (
              <option key={i} value={type}>
                {type}
              </option>
            ))}
          </Form.Control>
        </Col>
        {(column.type === "VARCHAR" || column.type === "CHAR") && (
          <Col md={2}>
            <Form.Label className="input_label">
              Length <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              value={column.length || ""}
              placeholder="Length"
              className="form_input_field"
              onChange={(e) =>
                handleColumnChange(index, "length", e.target.value)
              }
            />
          </Col>
        )}
        <Col md={1}>
          <Form.Label className="input_label d-flex align-items-center justify-content-center">
            PK
            <Tooltip
              title={`If checked, this will be set as the primary key for the selected table.`}
              placement="top-end"
            >
              <img
                src={Images.InfoIcon}
                alt="info"
                width="15"
                height="15"
                className="cursor_pointer ms-1"
              />
            </Tooltip>
          </Form.Label>
          <div className="d-flex justify-content-center mt-2">
          <Form.Control
            type="checkbox"
            className="form-check-input pk-checkbox"
            checked={column.pk}
            disabled={pkSelected && !column.pk}
            style={{
                transform: "scale(1.3)",
                margin: "0",
                cursor: "pointer"
            }}
            onChange={() => handleCheckboxChange(index, "pk")}
          />
          </div>
        </Col>
        <Col md={1}>
          <Form.Label className="input_label d-flex align-items-center justify-content-center">
            NN
            <Tooltip
              title={`If checked, this column will be added with a "not null" constraint.`}
              placement="top-end"
            >
              <img
                src={Images.InfoIcon}
                alt="info"
                width="15"
                height="15"
                className="cursor_pointer ms-1"
              />
            </Tooltip>
          </Form.Label>
          <div className="d-flex justify-content-center mt-2">
          <Form.Control
            type="checkbox"
            className="form-check-input"
            checked={column.nn}
            style={{
                transform: "scale(1.3)",
                margin: "0",
                cursor: "pointer"
            }}
            onChange={() => handleCheckboxChange(index, "nn")}
          />
          </div>
        </Col>
      </Row>
  </div>
);
};

const FormSection = ({
  name,
  setName,
  owner,
  setOwner,
  charset,
  setCharset,
  schema,
  setSchema,
  comments,
  setComments,
  columns,
  handleColumnChange,
  handleCheckboxChange,
  addColumn,
  removeColumn,
  pkSelected,
  databaseInfo,
}) => {
  // Determine the effective database type
  const getEffectiveDbType = () => {
    if (databaseInfo === "MySQL") return "mysql";
    if (databaseInfo === "MSSQL") return "mssql";
    if (databaseInfo === "PostgreSQL") return "postgres";
    return "postgres"; // default fallback
  };

  const effectiveDbType = getEffectiveDbType();

  return (
    <div>
      <Row className="mb-3">
        <Col md={6}>
      <Form.Label className="input_label">
            Table Name <span className="text-danger">*</span>
      </Form.Label>
      <Form.Control
        className="form_input_field"
        required
        type="text"
        value={name}
        placeholder="Enter table name"
        onChange={(e) => setName(e.target.value)}
      />
    </Col>

        <Col md={6}>
      <Form.Label className="input_label">Owner</Form.Label>
      <Form.Control
        as="select"
        value={owner}
        onChange={(e) => setOwner(e.target.value)}
        className="form_input_field"
      >
        <option value="">Select Owner</option>
        {["Table Owner", "Schema Owner", "Database Owner"].map((eng, i) => (
          <option key={i} value={eng}>
            {eng}
          </option>
        ))}
      </Form.Control>
    </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
      <Form.Label className="input_label">Charset</Form.Label>
      <Form.Control
        as="select"
        value={charset}
        onChange={(e) => setCharset(e.target.value)}
            className="form_input_field"
      >
        <option value="">Select Charset</option>
        {["utf8mb4", "utf8", "latin1", "ascii"].map((ch, i) => (
          <option key={i} value={ch}>
            {ch}
          </option>
        ))}
      </Form.Control>
    </Col>

        <Col md={6}>
      <Form.Label className="input_label">Schema</Form.Label>
      <Form.Control
        as="select"
        value={schema}
        onChange={(e) => setSchema(e.target.value)}
            className="form_input_field"
      >
        <option value="">Select Schema</option>
        {["public", "private"].map((coll, i) => (
          <option key={i} value={coll}>
            {coll}
          </option>
        ))}
      </Form.Control>
    </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
      <Form.Label className="input_label">Comments</Form.Label>
      <Form.Control
        as="textarea"
            rows={2}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        className="form_input_field"
        placeholder="Add any relevant comments"
      />
    </Col>
      </Row>

      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0">Table Columns</h6>
        </div>

    {columns.map((column, index) => (
      <ColumnForm
        key={index}
        index={index}
        column={column}
        handleColumnChange={handleColumnChange}
        handleCheckboxChange={handleCheckboxChange}
            removeColumn={removeColumn}
        pkSelected={pkSelected}
            canRemove={columns.length > 1}
            databaseInfo={databaseInfo}
      />
    ))}

        <div className="d-flex justify-content-start mt-3">
    <button
      type="button"
      onClick={addColumn}
      className="btn btn-link d-flex justify-content-start align-items-center"
    >
      <FiPlusCircle size={16} className="me-2" />
      Add Column
    </button>
        </div>
      </div>
    </div>
);
};

const CreateTablePopup = ({
  onClose,
  databaseName,
  systemUserId,
  appId,
  loading,
  setLoading,
  setCreateTable,
  databaseInfo,
  onTableCreated, // Add callback to refresh tables
  resourceAccessID,
}) => {
  const [columns, setColumns] = useState([
    { name: "", type: "", pk: false, nn: false },
  ]);
  const [pkSelected, setPkSelected] = useState(false);
  const [owner, setOwner] = useState("create-new");
  const [charset, setCharset] = useState("");
  const [schema, setSchema] = useState("public");
  const [name, setName] = useState("");
  const [comments, setComments] = useState("");
  const [dbType, setDbType] = useState(databaseInfo); // Use databaseInfo from props

  const handleColumnChange = (index, field, value) => {
    const updatedColumns = [...columns];
    updatedColumns[index] = { ...updatedColumns[index], [field]: value };
    setColumns(updatedColumns);
  };

  const handleCheckboxChange = (index, field) => {
    const updatedColumns = [...columns];

    if (field === "pk") {
      const isCurrentlySelected = updatedColumns[index].pk;
      if (isCurrentlySelected) {
        updatedColumns[index][field] = false;
        setPkSelected(false);
      } else {
        updatedColumns.forEach((col, idx) => {
          if (idx !== index) {
            col.pk = false;
          }
        });
        updatedColumns[index][field] = true;
        setPkSelected(true);
      }
    } else {
      updatedColumns[index][field] = !updatedColumns[index][field];
    }

    setColumns(updatedColumns);
  };

  const addColumn = () => {
    setColumns([
      ...columns,
      { name: "", type: "", pk: false, nn: false },
    ]);
  };

  const removeColumn = (index) => {
    if (columns.length > 1) {
      const updatedColumns = columns.filter((_, i) => i !== index);
      setColumns(updatedColumns);
      
      // Reset PK selection if the removed column was the primary key
      if (columns[index].pk) {
        setPkSelected(false);
      }
    }
  };

  const handleSubmit = async () => {
    // Validation
    if (!name.trim()) {
      showError("Table name is required");
      return;
    }

    // Validate table name format
    const tableNameRegex = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
    if (!tableNameRegex.test(name.trim())) {
      showError("Table name must start with a letter or underscore and contain only letters, numbers, and underscores");
      return;
    }

    // Validate columns
    const validColumns = columns.filter(col => col.name.trim() && col.type);
    if (validColumns.length === 0) {
      showError("At least one column with name and type is required");
      return;
    }

    // Check for duplicate column names
    const columnNames = validColumns.map(col => col.name.trim().toLowerCase());
    const uniqueNames = new Set(columnNames);
    if (uniqueNames.size !== columnNames.length) {
      showError("Column names must be unique");
      return;
    }

    // Validate column names format
    for (const col of validColumns) {
      if (!tableNameRegex.test(col.name.trim())) {
        showError(`Column name "${col.name}" must start with a letter or underscore and contain only letters, numbers, and underscores`);
        return;
      }
    }

    // Validate length for VARCHAR and CHAR
    for (const col of validColumns) {
      if ((col.type === "VARCHAR" || col.type === "CHAR") && (!col.length || col.length <= 0)) {
        showError(`Length is required for ${col.type} datatype`);
        return;
      }
    }

    setLoading(true);
    
    try {
      // Validate required parameters
      if (!appId) {
        showError("App ID is missing. Please refresh the page and try again.");
        return;
      }
      if (!systemUserId) {
        showError("System User ID is missing. Please refresh the page and try again.");
        return;
      }
      if (!databaseName) {
        showError("Database name is missing. Please select a database first.");
        return;
      }

      // Prepare columns data for API
      const columnsData = validColumns.map(col => ({
        name: col.name.trim(),
        type: col.type,
        length: col.length || null,
        pk: col.pk || false,
        nn: col.nn || false,
        default: null // Not implemented in UI yet
      }));

      const response = await createTable(
        appId,
        systemUserId,
        databaseName,
        name.trim(),
        columnsData,
        resourceAccessID
      );

      if (response.error) {
        const errorMessage = response.error.message || 
                           (Array.isArray(response.error) ? response.error.join(', ') : "Failed to create table");
        showError(errorMessage);
      } else {
        // Use backend success message if available, otherwise fallback to default
        const successMessage = response.message || response.data?.message || "Table created successfully";
        showSuccess(successMessage);
        setCreateTable(false);
        onClose();
        onTableCreated();
      }
    } catch (error) {
      showError("Failed to create table. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal 
      open={true} 
      handleClose={onClose}
      width="45%"
    >
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div className="d-flex align-items-center mb-1">
              {databaseInfo === "MySQL" && (
                <img src={Images.mysql} alt="MySQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "PostgreSQL" && (
                <img src={Images.pssql} alt="PostgreSQL" width="24" height="24" className="me-2" />
              )}
              {databaseInfo === "MSSQL" && (
                <img src={Images.mssql} alt="MSSQL" width="24" height="24" className="me-2" />
              )}
              <h3 className="border-0 customize-column-name mb-0">
                Create Table
              </h3>
            </div>
            <p className="text-muted mb-0 fs-14px">
              Create a new table in <code className="bg-light px-2 py-1 rounded">{databaseName}</code> database
            </p>
          </div>
          <CrossButton onClick={onClose} />
        </div>

        <FormSection
          name={name}
          setName={setName}
          owner={owner}
          setOwner={setOwner}
          charset={charset}
          setCharset={setCharset}
          schema={schema}
          setSchema={setSchema}
          comments={comments}
          setComments={setComments}
          columns={columns}
          handleColumnChange={handleColumnChange}
          handleCheckboxChange={handleCheckboxChange}
          addColumn={addColumn}
          removeColumn={removeColumn}
          pkSelected={pkSelected}
          databaseInfo={databaseInfo}
        />

        <Row className="pt-4 mb-3 justify-content-end">
          <Col sm="auto">
            <GeneralButton
              className="me-1"
              value="Cancel"
              color="#505050"
              variant="outlined"
              size="large"
              onClickEvent={onClose}
            />
          </Col>
          <Col sm="auto" className="me-sm-2 p-0">
            {loading ? (
              <GeneralButton
                variant="contained"
                onClickEvent={handleSubmit}
                disabled={true}
                className="me-1"
                value={<img src={Images.Loader} width="26px" height="26px" />}
                size="large"
              />
            ) : (
              <GeneralButton
                onClickEvent={handleSubmit}
                className="me-1"
                value="Create"
                variant="contained"
                size="large"
              />
            )}
          </Col>
        </Row>
    </div>
    </CustomModal>
  );
};

export default CreateTablePopup;
